import { useCallback } from "react";
import { useGenerateManagementReportNew } from "../services/reportService";

/**
 * Encapsulates the new management report PDF generation (refactored template).
 *
 * Mirrors useManagementReportHandler but calls GET /reports/management-new.
 * Converts the boolean includeYearSummary to the API format (0 | 1).
 *
 * TODO: once the legacy endpoint is removed, rename this hook to
 * useManagementReportHandler and delete the old one.
 */
export function useManagementReportNewHandler() {
  const generateManagementReportNew = useGenerateManagementReportNew();

  return useCallback(
    async (
      start_date: string,
      end_date: string,
      building_id: string,
      includeYearSummary: boolean
    ): Promise<Blob | null> => {
      const blob = await generateManagementReportNew.mutateAsync({
        start_date,
        end_date,
        building_id,
        year_summary: includeYearSummary ? 1 : 0,
      });
      return blob;
    },
    [generateManagementReportNew]
  );
}
